import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

import {
  CustomsHandlingApi,
  DocumentApi,
  EditContactDetailsViewModel,
  ResendNotificationViewModel,
  CustomsHandlingViewModel,
} from "@/openapi";
const customsHandlingApi = new CustomsHandlingApi(undefined, "");
const documentApi = new DocumentApi(undefined, "");
@Component({})
export default class CustomsHandlingItem extends Vue {
  @Prop() hawb!: string;
  @Prop() id!: number;

  phoneCopy: string = "";
  emailCopy: string = "";
  updatedContactDetailsLoading: boolean = false;
  updatedContactDetailsSuccess: boolean = false;
  updatedContactDetailsFailed: boolean = false;

  resendNotificationLoading: boolean = false;
  resendNotificationSuccess: boolean = false;
  resendNotificationFailed: boolean = false;

  loading: boolean = false;
  item: CustomsHandlingViewModel | null = null;

  mounted() {
    this.loadItem();
  }

  loadItem() {
    this.loading = true;
    customsHandlingApi.getItemById(this.id).then((response) => {
      if (response.data !== undefined) {
        this.item = response.data;
      }
      this.loading = false;
    });
  }

  downloadDocument(documentId: number, documentName: string) {
    documentApi.download(documentId).then((result) => {
      if (result.data.size === 0) {
        return;
      }
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", documentName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  dateFromDateTimeString(dateTimeString: string) {
    return moment(dateTimeString).format("DD-MM-YYYY");
  }

  timeFromDateTimeString(dateTimeString: string) {
    return moment(dateTimeString).format("HH:mm");
  }

  copyHawbToClipboard() {
    let hawb = this.$refs.hawb as HTMLInputElement;
    let tempInput = document.createElement("input");
    tempInput.style.position = "absolute";
    tempInput.style.left = "-10000px";
    tempInput.style.top = "-10000px";
    tempInput.value = hawb.value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
  }

  updateContactDetails() {
    this.updatedContactDetailsLoading = true;
    let model: EditContactDetailsViewModel = {
      hawb: this.item!.hawb,
      emailAddress: this.item!.deliveryAddress.contactEmail,
      phoneNumber: this.item!.deliveryAddress.contactPhone,
    };
    customsHandlingApi
      .editContactDetails(model)
      .then(() => {
        this.updatedContactDetailsLoading = false;
        this.updatedContactDetailsSuccess = true;
      })
      .catch(() => {
        this.updatedContactDetailsLoading = false;
        this.updatedContactDetailsFailed = true;
      });
  }

  resendNotification() {
    this.resendNotificationLoading = true;
    let model: ResendNotificationViewModel = {
      id: this.item!.id,
    };
    customsHandlingApi
      .resendNotification(model)
      .then(() => {
        this.resendNotificationLoading = false;
        this.resendNotificationSuccess = true;
      })
      .catch(() => {
        this.resendNotificationLoading = false;
        this.resendNotificationFailed = true;
      });
  }
}
